var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.agentSVG)?_c('div',{staticClass:"kai-message-icon"},[_c('div',{staticClass:"svg-wrapper",domProps:{"innerHTML":_vm._s(_vm.agentSVG)}})]):_c('div',{staticClass:"kai-message-icon"},[_c('img',{ref:"icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }